import Field from "../../../../../model/configurator/Field";
import { CustomFieldsEnum } from "../../../../../enums/CustomFieldsEnum";

export default class TwsMatchingUnitField extends Field {
    get type() {
        return CustomFieldsEnum.TWS_MATCHING_UNIT;
    }
}